import React from "react";
import KOGImage from "../kogImage";
import * as S from "./styles";

interface IKOGImageProps {
	images: string[];
	setImageIndex?: React.Dispatch<React.SetStateAction<number>>;
	onCLickCustomAreaCurrentImage?: () => void;
}
function KOGImageGroup({ images, setImageIndex = () => {}, onCLickCustomAreaCurrentImage = () => {} }: IKOGImageProps) {
	const [currentImageIndex, setCurrentImageIndex] = React.useState(0);
	function handleCurrentImageIndex(index: number) {
		setCurrentImageIndex(index);
		setImageIndex(index);
	}
	return (
		<S.Container>
			<S.AreaPreviewImage>
				{images.map((image, index) => (
					<KOGImage key={index} src={image} onClick={() => handleCurrentImageIndex(index)} />
				))}
			</S.AreaPreviewImage>
			<S.AreaCurrentImage
				onClick={() => {
					onCLickCustomAreaCurrentImage();
				}}
			>
				<img src={images[currentImageIndex]} alt="" />
			</S.AreaCurrentImage>
		</S.Container>
	);
}

export default KOGImageGroup;
